import React, { FC } from 'react';

import { useStarzplaySelectionIds } from '../../hooks/useStarzplaySelectionIds';
import starzplayGradient from '../../assets/starzplay-gradient.png';
import starzplayLogo from '../../assets/starzplay-logo.png';
import starzplayLogo2x from '../../assets/starzplay-logo@2x.png';
import starzplayGradient2x from '../../assets/starzplay-gradient@2x.png';

import styles from './SelectionTitle.module.css';

interface SelectionTitleProps {
    title: string;
    id: string;
}

export const SelectionTitle: FC<SelectionTitleProps> = ({ id, title }) => {
    const starzplaySelections = useStarzplaySelectionIds();

    if (starzplaySelections.includes(id)) {
        return (
            <>
                <img
                    src={starzplayGradient}
                    alt=""
                    className={styles.gradient}
                    srcSet={`${starzplayGradient} 1x, ${starzplayGradient2x} 2x`}
                />
                <h1 className={styles.heading}>
                    <img
                        src={starzplayLogo}
                        alt={title}
                        className={styles.logo}
                        srcSet={`${starzplayLogo} 1x, ${starzplayLogo2x} 2x`}
                    />
                </h1>
            </>
        );
    }

    return <h1 className={styles.title}>{title}</h1>;
};
